<script setup lang="ts">
import JournalsList from './components/journal-list/JournalsList.vue'
</script>

<template>
  <JournalsList />
</template>
